"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mobxReact = require("mobx-react");

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

var _GenericForm = _interopRequireDefault(require("@icare/forms/lib/components/GenericForm"));

var _LayoutField = _interopRequireDefault(require("@icare/forms/lib/components/LayoutField"));

var _Button = _interopRequireDefault(require("@icare/components/lib/Button"));

var _Message = _interopRequireDefault(require("@icare/components/lib/Message"));

var _Spinner = _interopRequireDefault(require("@icare/components/lib/Spinner"));

var _FormErrorSummary = _interopRequireDefault(require("@icare/forms/lib/components/FormErrorSummary"));

var _Form = _interopRequireDefault(require("@icare/forms/lib/models/Form"));

var _ConfigUtils = _interopRequireDefault(require("@icare/forms/lib/utils/ConfigUtils"));

var _AccessibilitySettings = _interopRequireDefault(require("./AccessibilitySettings"));

var _accessibilityForm = _interopRequireDefault(require("./accessibilityForm.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AccessibilityForm = /*#__PURE__*/function (_React$Component) {
  _inherits(AccessibilityForm, _React$Component);

  var _super = _createSuper(AccessibilityForm);

  function AccessibilityForm(props) {
    var _this;

    _classCallCheck(this, AccessibilityForm);

    _this = _super.call(this, props);
    _this.state = {
      form: null,
      formStatus: {
        success: false,
        error: false
      },
      resetBtnDisabled: false
    };
    _this._handleFormReset = _this._handleFormReset.bind(_assertThisInitialized(_this));
    _this._handleFormSubmit = _this._handleFormSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AccessibilityForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var cookies = new _universalCookie.default();
      var a11yCookie = cookies.get('icareCookieA11y');
      var initialValues = null;
      a11yCookie ? initialValues = a11yCookie : initialValues = {
        changeFont: 'icare-default',
        highContrast: 'turn-off'
      };

      _ConfigUtils.default.zipWithContent(_accessibilityForm.default, this.props.content.fields);

      this.setState({
        form: _Form.default.initialiseFromConfig(_accessibilityForm.default, initialValues)
      });
    }
  }, {
    key: "_handleFormSubmit",
    value: function _handleFormSubmit(values) {
      var cookies = new _universalCookie.default();
      cookies.set('icareCookieA11y', {
        changeFont: values.changeFont,
        highContrast: values.highContrast
      }, {
        path: '/'
      }); // Call Props' success

      this.props.onSuccess(values.highContrast, values.changeFont);

      _AccessibilitySettings.default.setAccessibilityFont();

      _AccessibilitySettings.default.setAccessibilityContrast();

      this.setState({
        formStatus: {
          success: true,
          error: false
        },
        form: _Form.default.initialiseFromConfig(_accessibilityForm.default, values),
        resetBtnDisabled: false
      });
    }
  }, {
    key: "_handleFormReset",
    value: function _handleFormReset() {
      var cookies = new _universalCookie.default();
      cookies.set('icareCookieA11y', {
        changeFont: 'icare-default',
        highContrast: 'turn-off'
      }, {
        path: '/'
      }); // Call Props' onReset

      this.props.onReset('icare-default', 'turn-off');

      _AccessibilitySettings.default.setAccessibilityFont();

      _AccessibilitySettings.default.setAccessibilityContrast();

      this.setState({
        formStatus: {
          success: true,
          error: false
        },
        form: _Form.default.initialiseFromConfig(_accessibilityForm.default, {
          changeFont: 'icare-default',
          highContrast: 'turn-off'
        }),
        resetBtnDisabled: true
      });
    }
  }, {
    key: "getFormStatusMessage",
    value: function getFormStatusMessage() {
      var _this$props$content = this.props.content,
          formSuccess = _this$props$content.formSuccess,
          formError = _this$props$content.formError;
      var _this$state = this.state,
          form = _this$state.form,
          formStatus = _this$state.formStatus;

      if (form && form.isPristine) {
        if (formStatus.success) {
          return {
            type: _Message.default.type.SUCCESS,
            intro: formSuccess.intro
          };
        }

        if (formStatus.error) {
          return {
            type: _Message.default.type.ERROR,
            intro: formError.intro
          };
        }
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$content2 = this.props.content,
          preferencesSection = _this$props$content2.preferencesSection,
          resetBtnLabel = _this$props$content2.resetBtnLabel,
          submitBtnLabel = _this$props$content2.submitBtnLabel;
      var _this$state2 = this.state,
          form = _this$state2.form,
          resetBtnDisabled = _this$state2.resetBtnDisabled;
      var formStatusMessage = this.getFormStatusMessage();
      return /*#__PURE__*/_react.default.createElement(_Spinner.default, {
        active: !form
      }, /*#__PURE__*/_react.default.createElement("h2", null, preferencesSection.title), form && /*#__PURE__*/_react.default.createElement(_GenericForm.default, {
        form: form,
        onSubmit: this._handleFormSubmit
      }, /*#__PURE__*/_react.default.createElement(_LayoutField.default, {
        form: form,
        fieldId: "changeFont"
      }), /*#__PURE__*/_react.default.createElement(_LayoutField.default, {
        form: form,
        fieldId: "highContrast"
      }), /*#__PURE__*/_react.default.createElement(_FormErrorSummary.default, {
        form: form
      }), formStatusMessage && /*#__PURE__*/_react.default.createElement(_Message.default, {
        type: formStatusMessage.type,
        title: formStatusMessage.title
      }, formStatusMessage.intro), /*#__PURE__*/_react.default.createElement("div", {
        className: "btn-holder"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        tag: "button",
        type: "button",
        onClick: this._handleFormReset,
        disabled: resetBtnDisabled && form.isPristine,
        variant: _Button.default.Variant.SECONDARY
      }, resetBtnLabel), /*#__PURE__*/_react.default.createElement(_Button.default, {
        tag: "button",
        type: "submit",
        disabled: form.isPristine || form.isDefault,
        variant: _Button.default.Variant.PRIMARY
      }, submitBtnLabel))));
    }
  }]);

  return AccessibilityForm;
}(_react.default.Component);

_defineProperty(AccessibilityForm, "propTypes", {
  content: _propTypes.default.object.isRequired,

  /**
   * optional onSuccess function
   */
  onSuccess: _propTypes.default.func,
  onReset: _propTypes.default.func
});

_defineProperty(AccessibilityForm, "defaultProps", {
  onSuccess: function onSuccess() {},
  onReset: function onReset() {}
});

var _default = (0, _mobxReact.observer)(AccessibilityForm);

exports.default = _default;
//# sourceMappingURL=AccessibilityForm.js.map